import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, formDataFlat, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IChangeDeclarationTrendyolStatusRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type IChangeDeclarationTrendyolStatusRepo = IRepo<[id: (number | string)[], statusId: number | string, filter: number | string], IChangeDeclarationTrendyolStatusRepoResponse>;

export const ChangeDeclarationTrendyolStatusRepoType = Symbol.for('ChangeDeclarationTrendyolStatusRepoType');

@bind(ChangeDeclarationTrendyolStatusRepoType)
export class ChangeDeclarationTrendyolStatusRepo implements IChangeDeclarationTrendyolStatusRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: (number | string)[], trendyol_state_id: number | string, filter: number | string) {
    try {
      const body = new FormData();
      let mappedBody: any = formDataFlat({ declaration_id: id, trendyol_state_id, filter });

      appendToFormData(mappedBody, body);

      const url = urlMaker('/api/admin/declaration/trendyol/updateState');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 422 || result.status === 400) {
        return {
          status: 400 as 400,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
